<cc-ng1-user-list
  [userStats]="userStats"
  [userList]="userList"
  [state]="state"
  [userIndex]="id"
  *ngIf="userList"
></cc-ng1-user-list>

<cc-section>
  <cc-ng1-users-alert [userStats]="userStats" *ngIf="userStats && state !== 'inactive' && state !== 'pending'"></cc-ng1-users-alert>
  <cc-ng1-user-details
    [user]="user"
    [userIndex]="id"
    [state]="state"
    *ngIf="user"
    class="users-content"
  ></cc-ng1-user-details>
</cc-section>
